import React from 'react'
import { Navigate, Outlet, Route } from 'react-router-dom';
import { connect } from 'react-redux'
import Spinner from './Spinner'
import { refreshUser } from '../../actions/authActions'
// import { Loading } from '../Loading/loading';
import {
  Container,
  Row,
} from 'reactstrap';

const PrivateRoute = ({ element: Component, isAuthenticated, loading, token, location, refreshUser, ...rest }) => {
  // const pathname = location.pathname
  React.useEffect(() => {
    refreshUser()
    // eslint-disable-next-line
  }, [location]);

  if (isAuthenticated) {
    return  <Outlet /> //<Route {...rest} render={props => <Component {...props} />} />;
  } else if (loading) {
    return (<>
      <Container>
        <Row>
          <span className='ml-auto mr-auto' style={{marginTop: '20%', textAlign: 'center'}}>
            <Spinner /><br />
            Dane są pobierane z serwera...
          </span>
        </Row>
      </Container>
    </>)
  }
  return <Navigate to="/auth/login" />;
}

const mapStateToProps = state => ({
  isAuthenticated: state.authReducer.isAuthenticated,
  loading: state.authReducer.auth_loading,
  token: state.authReducer.token
})

export default connect(mapStateToProps, {refreshUser})(PrivateRoute)